import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { Box } from 'pcln-design-system'
import NoSSR from 'react-no-ssr'

import { AdContainer } from '../../containers/ad-container'
import { fireGtm } from '../../util/flyGaLogic'
import { filterAdId } from '../../constants/constants'
import { airSearchRequestModel } from '../../services/airSearch/airSearchRequest'

const includedAirlineCheck = airlineCode => {
  // Subsequent filtered updates are stored in airSearchRequest
  let includedCarriers
  includedCarriers = get(
    airSearchRequestModel,
    'sliceFilters[0].includedCarriers',
    []
  )

  return includedCarriers.length === 1 && includedCarriers.includes(airlineCode)
}

const getFilterAdIsVisible = () =>
  !!document.getElementById(filterAdId)?.firstChild?.firstChild

class SponsoredFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasRendered: false }
  }

  static propTypes = {
    airlines: PropTypes.array.isRequired,
    activeTabId: PropTypes.number,
    updateAirlineFiltersUI: PropTypes.func.isRequired,
    updateAirlineFiltersReq: PropTypes.func.isRequired,
    pclnBootstrapData: PropTypes.object.isRequired,
    listingsFilterCall: PropTypes.func.isRequired,
  }

  delayedStateUpdate = () => {
    return (...args) => {
      const { activeTabId, pclnBootstrapData } = this.props
      const isSBS = pclnBootstrapData?.isRoundTrip === true
      this.props.updateAirlineFiltersReq(...args, { isSBS, activeTabId })
      this.props.listingsFilterCall(this.props.pclnBootstrapData, 'filter')
    }
  }

  componentDidUpdate() {
    // Marketing team provides "carrierCode" via this global event
    if (window.PCLN && window.PCLN.pclnEventDispatcher) {
      window.PCLN.pclnEventDispatcher.register(
        'APPLY_AIR_CARRIER_FILTER',
        data => {
          const payload = { value: data.carrierCode, checked: true }
          this.props.updateAirlineFiltersUI(payload, { isOnlyClick: true })
          if (!includedAirlineCheck(data.carrierCode)) {
            // GA logic to capture carrier code
            fireGtm(
              'send',
              'event',
              'MFLY-Listings',
              'Sponsored filter click',
              data.carrierCode
            )
            this.delayedStateUpdate(true)(
              payload,
              { isOnlyClick: true },
              this.props.airlines
            )
          }
        }
      )

      if (!this.state.hasRendered && getFilterAdIsVisible()) {
        const { airlines = [] } = this.props
        const aaAvailable = !!airlines.find(a => a.value === 'AA')
        fireGtm(
          'send',
          'event',
          'MFLY-Listings',
          'Sponsored filter visible',
          `AA carrier option ${
            aaAvailable ? 'is' : 'not'
          } available on listings`
        )
        this.setState({ hasRendered: true })
      }
    }
  }

  renderAd = (adId, isSticky = false, minScreenSize, marginBottom = 0) => {
    return (
      <NoSSR>
        <AdContainer
          adId={adId}
          isSticky={isSticky}
          minScreenSize={minScreenSize}
          marginBottom={marginBottom}
        />
      </NoSSR>
    )
  }

  render() {
    return (
      <Box px='8px' mb={this.state.hasRendered && '8px'}>
        {this.renderAd(
          filterAdId,
          false,
          'desktop',
          32
        )}
      </Box>
    )
  }
}

export { includedAirlineCheck, SponsoredFilter }
